import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CONTROL } = ServerConstants;
const { REQUEST_CONTROL_F1, REQUEST_CONTROL_F2, REQUEST_CONTROL_F3, REQUEST_CONTROL_F4 } = ServiceConstants;


export async function deleteUserData(email: string) {
  const requestId = REQUEST_CONTROL_F1;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTROL}/f1`, { email: email });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, deleteUserData, [email], requestId);
  }
}

export async function truncateDatabase() {
  const requestId = REQUEST_CONTROL_F2;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTROL}/f2`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, truncateDatabase, [], requestId);
  }
}

export async function saveDatabase() {
  const requestId = REQUEST_CONTROL_F3;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTROL}/f3`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, saveDatabase, [], requestId);
  }
}

export async function resetDatabase() {
  const requestId = REQUEST_CONTROL_F4;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_CONTROL}/f4`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, saveDatabase, [], requestId);
  }
}